module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, _vm._l((_vm.breadcrumbs), function(crumb) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": crumb.link
      }
    }, [_vm._v(_vm._s(crumb.title))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1488e9f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumBreadcrumbs.vue
// module id = 1956
// module chunks = 2